import { render, staticRenderFns } from "./SelectCrime.vue?vue&type=template&id=edaceadc&scoped=true&"
import script from "./SelectCrime.vue?vue&type=script&lang=ts&"
export * from "./SelectCrime.vue?vue&type=script&lang=ts&"
import style0 from "./SelectCrime.vue?vue&type=style&index=0&id=edaceadc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edaceadc",
  null
  
)

export default component.exports